"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.function.name");
//存储数据
var state = {
  iframeComponentsArr: [],
  hasOpenIframePageArr: []
};
var mutations = {
  SET_IFRAME_ISOPEN: function SET_IFRAME_ISOPEN(state, route) {
    var r = state.iframeComponentsArr.filter(function (item) {
      return item.name == route.name;
    });
    var d = state.iframeComponentsArr.filter(function (item) {
      return item.children[0].meta.hasOpen && item.name !== route.name;
    });
    state.hasOpenIframePageArr = r.concat(d);
    // console.log('打开了页面',state)
  },
  SET_IFRAME_COMPONENTS: function SET_IFRAME_COMPONENTS(state, arr) {
    state.iframeComponentsArr = arr;
  },
  SET_IFRAME_CLOSE: function SET_IFRAME_CLOSE(state, route) {
    //关闭SQEMS的页面时，移除hasOpenIframePageArr里改页面的路由信息
    //设置iframeComponentsArr里该页面路由meta里的hasOpen为false
    state.hasOpenIframePageArr = state.hasOpenIframePageArr.filter(function (item) {
      return item.children[0].path !== route.path;
    });
    var target = state.iframeComponentsArr.find(function (item) {
      return item.children[0].path === route.path;
    });
    target.children[0].meta.hasOpen = false;
  }
};
var actions = {
  getIframeComponent: function getIframeComponent(_ref, payload) {
    var commit = _ref.commit;
    commit('SET_IFRAME_COMPONENTS', payload);
  },
  //判断是否是SQEMS的页面
  isOpenIframePage: function isOpenIframePage(_ref2, payload) {
    var commit = _ref2.commit,
      state = _ref2.state;
    var target = state.iframeComponentsArr.find(function (item) {
      return item.children[0].path === payload.path;
    });
    if (target && !target.children[0].meta.hasOpen) {
      // console.log('首次打开了SQEMS的某个模块',state,payload)
      target.children[0].meta.hasOpen = true;
      commit("SET_IFRAME_ISOPEN", target);
    }
  },
  //关闭SQEMS页面的tag时
  delIframePage: function delIframePage(_ref3, payload) {
    var commit = _ref3.commit;
    // console.log('关闭了SQEMS的页面==',payload)
    var target = state.iframeComponentsArr.find(function (item) {
      return item.children[0].path === payload.path;
    });
    if (target && target.children[0].meta.hasOpen) {
      target.children[0].meta.hasOpen = false;
      commit('SET_IFRAME_CLOSE', payload);
    }
  }
};
var _default = exports.default = {
  namespaced: true,
  //命名空间
  state: state,
  mutations: mutations,
  actions: actions
};